/**
 * defer function for non blocking script
 * usage => defer(cd);
 */
export default cb => {
  const t = setTimeout(() => {
    cb();
    clearTimeout(t);
  }, 0);
};
